import React, {useState} from "react";
import TabTitle from "../../components/tabTitle/TabTitle";
import './MarketAnalysisStyles.css'
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import withLoadingAnimation from "../AnimationWrapper/AnimationWrapper";
import MarketAnalysisDetailComponent from "./components/MarketAnalysisDetailComponent";
import MarketAnalysisContentComponent from "./components/MarketAnalysisContentComponent";
import {MarketAnalysisContainerProps} from "../../containers/marketAnalysis/MarketAnalysisContainer";
import TabFooter from "../tabFooter/TabFooter";
import Tab from "../tab/Tab";

const MarketAnalysisContent = styled.div`
    height: 100%;

    @media (min-width: 481px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        height: 100%;

        h3 {
          margin-top: 0px;
        }
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow-y: auto;
    }
`;

const MarketAnalysisComponent: React.FC<MarketAnalysisContainerProps> = ({isTabSelected}) => {
    const { t } = useTranslation();
    const [detailsOpen, setDetailsOpen] = useState<boolean>(false);
    const tabContent = (
      <MarketAnalysisContent id={'MarketAnalysisContent'} className='content'>
          {
              withLoadingAnimation(
                  <MarketAnalysisDetailComponent closeDetails={() => setDetailsOpen(false)}/>,
                  <MarketAnalysisContentComponent openDetails={() => setDetailsOpen(true)}/>,
                  detailsOpen
              )
          }
      </MarketAnalysisContent>
    );

    return (
      <Tab
        isOpen={ isTabSelected }
        title={
          <TabTitle
              title={ t('marketAnalysis.title')}
              isTabSelected={isTabSelected}
          />
        }
        body={ tabContent }
        footer={ <TabFooter /> }
      />
    );
};

export default MarketAnalysisComponent;
